import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import getAxios from './../lib/axios/axios';

declare global {
  interface Window {
    ApplePaySession?: {
      canMakePayments(): boolean;
    };
  }
}

function Native() {
  const { authcode } = useParams();
  const [amount, setAmount] = useState<string>("");
  const [launcher, setLauncher] = useState<any>(null);

  useEffect(() => {
    const initApplePay = async () => {
      try {
        const axios = getAxios();
        // Create a widget URL with apple_pay type to get a nonce
        const urlResponse = await axios.post("/demo/url", {
          auth_code: authcode,
          type: "apple_pay"
        });

        const applePayLauncher = new window.PushCash.ApplePay({
          url: urlResponse.data.url
        });
        setLauncher(applePayLauncher);
      } catch (error) {
        console.error("Failed to initialize Apple Pay:", error);
      }
    };

    if (authcode) {
      initApplePay();
    }
  }, [authcode]);

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAmount(e.target.value);
  };

  const handleApplePayClick = () => {
    launcher.display({
      amount: parseFloat(amount) * 100, // convert to cents
      direction: 'cash_in',
      currency: 'USD',
      onAuthorize: async (tokenId: string) => {
        try {
          const axios = getAxios();
          const res = await axios.post("/demo/authorize", {
            amount: parseFloat(amount) * 100,
            direction: 'cash_in',
            currency: 'USD',
            auth_code: authcode,
            token: tokenId,
            type: 'apple_pay'
          });
          return res.data.status;
        } catch (error) {
          console.error("Failed to authorize payment:", error);
          return 'declined';
        }
      },
      onComplete: async () => {
        console.log("Payment completed successfully");
        setAmount("");
      }
    });
  };

  return (
    <div>
      <form>
        <input
          type="number"
          step="0.01"
          placeholder="Enter amount in dollars"
          value={amount}
          onChange={handleAmountChange}
        />
        <button
          type="button"
          onClick={handleApplePayClick}
        >
          Apple Pay
        </button>
      </form>
    </div>
  );
}

export default Native;
